import { HttpClient, HttpEventType, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {
  IPatientArchivesQuery,
  IPatientFilesQuery,
  IPatientFilesResponse,
} from '../../interfaces';
import { map, Observable, tap } from 'rxjs';
import { environment as env } from 'src/environment/environment';
import { shakeParams } from '../../classes';

@Injectable({
  providedIn: 'root',
})
export class PatientFilesService {
  private readonly _http = inject(HttpClient);

  public getPatientsWithFiles(
    params: IPatientFilesQuery | HttpParams
  ): Observable<IPatientFilesResponse> {
    params = shakeParams(params) as HttpParams;

    return this._http
      .get<IPatientFilesResponse>(
        `${env.apiGateway}/patient/patient-with-files`,
        {
          params,
        }
      )
      .pipe(
        map((response: IPatientFilesResponse) => {
          if (!response.data) {
            return { data: [] };
          }

          return {
            data: response.data.map(item => {
              return {
                ...item,
                checked: false,
              };
            }),
          };
        })
      );
  }

  public getPatientArchives(
    params: IPatientArchivesQuery | HttpParams,
    name: string
  ): Observable<any> {
    params = shakeParams(params) as HttpParams;

    return this._http
      .get(`${env.apiGateway}/file/patients-files-archive`, {
        params,
        responseType: 'blob',
        observe: 'events',
        reportProgress: true,
      })
      .pipe(
        tap(event => {
          if (event.type === HttpEventType.Response) {
            const link = document.createElement('a');
            const url = window.URL.createObjectURL(event.body!);
            link.href = url;
            link.download = `${name}.zip`;
            link.click();
            window.URL.revokeObjectURL(url);
          }
        })
      );
  }
}
